import { Route } from '@angular/router';
import { ShellPartner, ShellPromoters } from '@ribera-web/shell-promoters';
import { authGuard } from '@ribera-web/auth-data-acess';
import { paymentGuard } from '@ribera-web/payments';

export const appRoutes: Route[] = [
  {
    path: '',
    component: ShellPromoters,
    children: [
      {
        path: '',
        redirectTo: 'home',
        pathMatch: 'full',
      },
      {
        path: 'home',
        loadChildren: () =>
          import('@ribera-web/home-promoters-feature').then((m) => m.homePromotersFeatureRoutes),
      },
      {
        path: 'promotor-dashboard',
        canActivate: [authGuard],
        loadChildren: () =>
          import('@ribera-web/promoters-dashboard-feature').then((m) => m.promotersDashboardFeatureRoutes),
      },
      // {
      //   path: 'booking',
      //   loadChildren: () =>
      //     import('@ribera-web/accommodation-feature').then(
      //       (m) => m.accommodationFeatureRoutes
      //     ),
      // }
      {
       path: 'promotor-bookings',
       canActivate: [authGuard],
        loadChildren: () =>
          import('@ribera-web/accommodation-feature').then(
            (m) => m.accommodationFeatureRoutes
          ),
      },
      {
        path: 'promotor-member-booking-feature',
        canActivate: [authGuard],
        loadChildren: () =>
          import('@ribera-web/member-booking-feature').then(
            (m) => m.memberBookingFeatureRoutes
          ),
      },
      {
        path: 'promotor-wallet',
        canActivate: [authGuard],
        loadComponent: () =>
          import('@ribera-web/wallet-feature').then(
            (m) => m.PromotersMyWalletFeature
          ),
      },
      // {
      //   path: 'promotor-wallet',
      //   canActivate: [authGuard],
      //   loadComponent: () =>
      //     import('@ribera-web/page-under-construction').then(
      //       (m) => m.PageUnderConstruction
      //     ),
      // },
      {
        path: 'promotor-my-data',
        canActivate: [authGuard],
        loadChildren: () =>
          import('@ribera-web/promoter-data-feature').then(
            (m) => m.promoterDataFeatureRoutes
          ),
      },
      {
        path: 'promotor-checkout',
        canActivate: [authGuard],
        loadChildren: () =>
          import('@ribera-web/booking-checkout-feature').then(
            (m) => m.bookingCheckoutFeatureRoutes
          ),
      },
      {
        path: 'promotor-payment',
        canActivate: [
          paymentGuard
        ],
        loadChildren: () =>
          import('@ribera-web/payments-feature').then(
            (m) => m.paymentsFeatureRoutes
          ),
      },
      {
        path: 'fullday',
        canActivate: [authGuard],
        loadChildren: () =>
          import('@ribera-web/fullday-manager-feature').then(
            (m) => m.fulldayManagerFeatureRoutes
          ),
      },
      // {
      //   path: 'promotor-fullday',
      //   canActivate: [authGuard],
      //   loadComponent: () =>
      //     import('@ribera-web/page-under-construction').then(
      //       (m) => m.PageUnderConstruction
      //     ),
      // },
      {
        path: 'promotor-my-clients',
        canActivate: [authGuard],
        loadChildren: () =>
          import('@ribera-web/promoter-my-clients-feature').then(
            (m) => m.promoterMyClientsFeatureRoutes
          ),
      },
      {
        path: 'promotor-my-commissions',
        canActivate: [authGuard],
        loadChildren: () =>
          import('@ribera-web/commision-feature').then(
            (m) => m.commisionFeatureRoutes
          ),
      },
      {
        path: 'promotor-my-benefits',
        canActivate: [authGuard],
        loadChildren: () =>
          import('@ribera-web/benefit-feature').then(
            (m) => m.benefitFeatureRoutes
          ),
      },
      {
        path: 'promotor-reservas',
        loadChildren: () =>
          import('@ribera-web/booking-management-feature').then(
            (m) => m.bookingManagementFeatureRoutes
          ),
      },
      {
        path: 'promotor-courses',
        canActivate: [authGuard],
        loadComponent: () =>
          import('@ribera-web/page-under-construction').then(
            (m) => m.PageUnderConstruction
          ),
      },
      {
        path: 'member-booking-feature',
        canActivate: [authGuard],
        loadChildren: () =>
          import('@ribera-web/member-booking-feature').then(
            (m) => m.memberBookingFeatureRoutes
          ),
      },
      //RUTAS PARA USUARIO SOCIO

    ]
  },
  // {
  //   path: '',
  //   component: ShellPartner,
  //   children: [
  //     {
  //       path: 'dashboard',
  //       canActivate: [authGuard],
  //       loadChildren: () =>
  //         import('@ribera-web/dashboard-feature').then(
  //           (m) => m.dashboardFeatureRoutes
  //         ),
  //     },
  //     {
  //       path: 'data',
  //       canActivate: [authGuard],
  //       loadChildren: () =>
  //         import('@ribera-web/user-data-feature').then(
  //           (m) => m.userDataFeatureRoutes
  //         ),
  //     },
  //     {
  //       path: 'member-booking-feature',
  //       canActivate: [authGuard],
  //       loadChildren: () =>
  //         import('@ribera-web/member-booking-feature').then(
  //           (m) => m.memberBookingFeatureRoutes
  //         ),
  //     },
  //     {
  //       path: 'bookings',
  //       loadChildren: () =>
  //         import('@ribera-web/accommodation-feature').then(
  //           (m) => m.accommodationFeatureRoutes
  //         ),
  //     },
  //     {
  //       path: 'checkout',
  //       canActivate: [authGuard],
  //       loadChildren: () =>
  //         import('@ribera-web/booking-checkout-feature').then(
  //           (m) => m.bookingCheckoutFeatureRoutes
  //         ),
  //     },
  //     {
  //       path: 'payment',
  //       canActivate: [
  //         paymentGuard
  //       ],
  //       loadChildren: () =>
  //         import('@ribera-web/payments-feature').then(
  //           (m) => m.paymentsFeatureRoutes
  //         ),
  //     },
  //   ]
  // },
  {
    path: 'auth',
    loadChildren: () =>
      import('@ribera-web/auth-shell').then((m) => m.authShellRoutes),
  }
];